import React, { useState, useEffect, useRef } from "react";
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import CSIntroImage1 from "../../images/kroger-intro-img-01.png";
import CSIntroImage2 from "../../images/kroger-intro-img-02.png";
import CSIntroImage3 from "../../images/kroger-intro-img-03.png";

export default function KrogerCsIntro(props) {
  const [elementTop, setElementTop] = useState(0);
  const [elementBottom, setElementBottom] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const yOffset = 300;
  const easing = [0.42, 0, 0.58, 1];
  const ref = useRef();

  const setValues = () => {
    setElementTop(ref.current.offsetTop);
    setElementBottom(ref.current.offsetTop + ref.current.offsetHeight);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    if (!ref.current) return;
    props.isLoaded && setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });
  const y0 = useTransform(scrollY, [elementTop - clientHeight * 0.9, elementTop - clientHeight / 3], [yOffset, 0], easing);
  const y1 = useTransform(scrollY, [elementTop - clientHeight * 0.7, elementTop - clientHeight / 3], [yOffset, 0], easing);
  const y2 = useTransform(scrollY, [elementTop - clientHeight * 0.4, elementTop - clientHeight / 3], [yOffset, 0], easing);
  const op0 = useTransform(scrollY, [elementTop - clientHeight * 0.9, elementTop - clientHeight / 3], [0, 1], easing);
  const op1 = useTransform(scrollY, [elementTop - clientHeight * 0.7, elementTop - clientHeight / 3], [0, 1], easing);
  const op2 = useTransform(scrollY, [elementTop - clientHeight * 0.4, elementTop - clientHeight / 3], [0, 1], easing);
  return (
    <div className="cs-intro-section section-gap" onLoad={setValues}>
      <div className="container">

        <div className="row d-flex flex-wrap justify-center">
          <div className="col">
            <h3>Tapping into the new <br />
                        market of voice commerce</h3>
            <p>With 5 billion voice-enabled devices in the market, voice commerce is a new channel for growth. Our client, a national retail giant, wanted to make grocery shopping simple and contextual for its millions of customers. They partnered with us to build the first voice-enabled grocery shopping assistant.</p>
          </div>
        </div>

        <div className="row d-flex flex-wrap align-v-center two-col">
          <div ref={ref} className="col">
            <div className="intro-img">
              <motion.img style={{ y: y0, opacity: op0 }} src={CSIntroImage1} alt="voice-enabled  grocery shopping" title="Voice Shopping" />
              <motion.img style={{ y: y1, opacity: op1 }} src={CSIntroImage2} alt="voice commerce platform" title="Voice Commerce" />
              <motion.img style={{ y: y2, opacity: op2 }} src={CSIntroImage3} alt="Google Home Voice-enabled Platform" title="Google Home Voice-enabled Shopping" />
            </div>
          </div>
          <div className="col">
            <h3>Don’t stop living <br />
                            for shopping groceries</h3>
            <p>Together with our client team, we conducted a series of customer interviews and learned that people have difficulty keeping up with their grocery shopping. Consumers constantly find themselves forgetting to order essential items.</p>

            <p>They often remember things that they are running out of when cooking (making a delicious cake) or working (doing laundry) with their hands full. Some elderly customers tend to forget to buy the routine items they need. Many customers are busy professionals and families who don’t have time to visit stores, and they want their groceries delivered to their doorstep.</p>
          </div>
        </div>

        <div className="row d-flex flex-wrap justify-center">
          <div className="col">
            <h3>Introducing Voice Shopping </h3>
            <p>We designed and built an AI-powered voice assistant that allows millions of consumers to fill up their shopping carts with the items they need and order them without needing to stop what they are doing - just with their voice. We were able to save them time, pain, and trips to the stores.</p>
          </div>
        </div>

      </div>
    </div>
  );
}